import { useMemo, useState } from 'react';
import { generatePath, Navigate } from 'react-router-dom';
import { useTranslate } from 'react-translate.ts';
import { FormField, Input } from '@tcc-online/input-components';
import { Button, ButtonVariants } from '@tcc-online/common-components';
import { css, cx } from '@emotion/css';

import {
    RESET_PASSWORD_PATH,
    TOKEN_PATH,
} from '../../../constants/route.constants';
import styles from './ResetTokenPage.module.scss';
import { useTheme } from '@tcc-online/react-theme-provider';
import { TRANSLATIONS_FORGOTTEN_PASS_KEY } from '../../../constants/translation.constants';
import AuthLayout from '../AuthLayout/AuthLayout';
import AuthCard from '../../../components/auth/AuthCard/AuthCard';

export default function ResetTokenPage() {
    const translate = useTranslate(TRANSLATIONS_FORGOTTEN_PASS_KEY);
    const [theme] = useTheme();

    const [token, setToken] = useState('');
    const [success, setSuccess] = useState(false);

    const hasToken = useMemo(() => !!token && token.trim() !== '', [token]);

    return <AuthLayout>{render()}</AuthLayout>;

    function render() {
        if (success) {
            return (
                <Navigate
                    to={generatePath(`${RESET_PASSWORD_PATH}/${TOKEN_PATH}`, {
                        token,
                    })}
                    relative="path"
                />
            );
        }

        return (
            <AuthCard
                isLoading={false}
                header={
                    <div
                        className={cx(
                            styles.title,
                            css({ color: theme.primaryColor }),
                        )}
                    >
                        {translate('reset-title')}
                    </div>
                }
            >
                <form onSubmit={submit}>
                    <FormField>
                        <Input
                            name="token"
                            label={translate('code')}
                            value={token}
                            onChange={handleChange}
                        />
                    </FormField>
                    <div className={styles.submit}>
                        <Button
                            type="submit"
                            variant={
                                hasToken
                                    ? ButtonVariants.positive
                                    : ButtonVariants.disabled
                            }
                            disabled={!hasToken}
                        >
                            {translate('request')}
                        </Button>
                    </div>
                </form>
            </AuthCard>
        );
    }

    function handleChange(ev: any) {
        setToken(ev.target.value);
    }

    function submit() {
        if (!hasToken) {
            return;
        }

        setSuccess(true);
    }
}
